import { api } from './api';

// Phase 4a support bot (Vanthor): review its answers, rate them 👍/👎, try it in the playground.

export type BotAnswerFilter = 'all' | 'shown' | 'shadow' | 'unrated' | 'down' | 'possible_safety';

export interface BotFeedbackSummary { verdict: 'up' | 'down'; correctIntent: string | null; note: string | null; staffId: number | null; createdAt: string }
export interface BotAnswerItem {
    id: string; query: string; outcome: string; oldIntent: string | null;
    botIntent: string | null; botAction: string | null; botConfidence: number | null; botLatencyMs: number | null;
    botModel: string | null; botReply: string | null; shownToUser: boolean; createdAt: string; feedback: BotFeedbackSummary | null;
}
export interface BotReply {
    action: string; intent: string | null; options: string[] | null; confidence: number | null; gate: boolean;
    reply: { lang: string; text: string; needsData: boolean; quick: string[] }; model: { name: string };
    latencyMs: number; wouldShowLive: boolean; mode: 'off' | 'shadow' | 'live';
    // Phase 4c: present when tested "as a user" on an answer that needs their data.
    filled?: { asUid: string; found: boolean; role: string | null; text: string | null; missing: string[] };
}
// Phase 4b/4c rollout status (GET /admin/support/bot-status).
export interface BotStatus {
    mode: 'off' | 'shadow' | 'live'; livePercent: number; liveRoles: string[]; liveCities: string[]; liveIntents: string[];
    dataIntents: string[]; dataIntentsAvailable: string[];
    brake: { windowHours: number; minRatings: number; maxDownPct: number; engaged: boolean; down: number; total: number };
}
export const getBotStatus = () => api.get<BotStatus>(`/admin/support/bot-status`);
export interface BotFeedbackInput { verdict: 'up' | 'down'; correctIntent?: string | null; note?: string | null }

export const getBotAnswers = (opts: { filter: BotAnswerFilter; cursor?: string | null; limit?: number }) => {
    const params = new URLSearchParams();
    params.append('filter', opts.filter);
    params.append('limit', String(opts.limit ?? 30));
    if (opts.cursor) params.append('cursor', opts.cursor);
    return api.get<{ items: BotAnswerItem[]; nextCursor: string | null }>(`/admin/support/bot-answers?${params.toString()}`);
};

export const postBotAnswerFeedback = (id: string, body: BotFeedbackInput) =>
    api.post(`/admin/support/bot-answers/${id}/feedback`, body);

export const postBotPlayground = (text: string, asUid?: string) =>
    api.post<BotReply>(`/admin/support/bot-playground`, { text, ...(asUid ? { asUid } : {}) });

export const postBotPlaygroundFeedback = (body: BotFeedbackInput & { text: string; botIntent?: string | null }) =>
    api.post(`/admin/support/bot-playground/feedback`, body);

export const getBotIntents = () =>
    api.get<{ intents: string[]; liveIntents: string[]; mode: 'off' | 'shadow' | 'live' }>(`/admin/support/bot-intents`);

// "driver_bonus_incentive" → "Driver · bonus incentive"
export const intentLabel = (id: string | null | undefined) => {
    if (!id) return '—';
    const [head, ...rest] = id.split('_');
    const group = ({ rider: 'Rider', driver: 'Driver', account: 'Account', safety: 'Safety', support: 'Support' } as Record<string, string>)[head];
    return group ? `${group} · ${rest.join(' ')}` : id.replace(/_/g, ' ');
};
